<template>
  <div>
    <page v-if="engine.length">
      <div :style="'height: 350px'"></div>
      <h2 style="text-align: center">
        <span v-if="engine == 'port'">Port Engine</span>
        <span v-else>Starboard Engine</span>
      </h2>
    </page>
    <page v-for="page in component_pages" :key="page">
      <h2 v-if="page == 1" style="text-align: center">Components Maintained under Schema</h2>
      <table cellspacing="0">
        <thead>
        <tr>
          <td>
            Component
          </td>
          <td>
            Baseline interval
          </td>
          <td>
            Adjusted interval
          </td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(component, i) in getPageComponents(page-1)" :key="i">
          <td>{{ component.name }}</td>
          <td>{{ component.baseline_interval }}</td>
          <td>{{ component.adjusted_interval }}</td>
        </tr>
        </tbody>
      </table>
    </page>
    <page v-for="page in task_pages" :key="page">
      <h2 v-if="page == 1" style="text-align: center">Key Performance Indicators (KPIs) & Charts</h2>

      <div v-for="(task, index) in getPageTasks(page-1)" style="margin-top: 12px;" :key="index">
        <h3>{{ task['component'] }} - {{ task['action'] }} {{ (task['completed'] ? '- Completed' : '') }}</h3>
        <table cellspacing="0">
          <thead>
          <tr>
            <td colspan="2">KPI</td>
            <td>Value</td>
            <td>Unit</td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td colspan="2">Current “Usage Factor”</td>
            <td>{{ (task['usage_factor']).toPrecision(2) }}</td>
            <td>-</td>
          </tr>
          <tr>
            <td colspan="2">Average “Usage Factor”</td>
            <td>{{ (task['usage_factor_rolling']).toPrecision(2) }}</td>
            <td>-</td>
          </tr>
          <tr>
            <td colspan="2">Delta (Average - Current) “Usage Factor”</td>
            <td>{{ (task['usage_factor_rolling_diff']).toPrecision(2) }}</td>
            <td>-</td>
          </tr>
          <tr>
            <td rowspan="2" style="border-bottom: 1px solid black">Remaining Useful Life (RUL)</td>
            <td>Absolute interval</td>
            <td>{{ task['rul_absolute'] }}</td>
            <td>Hours</td>
          </tr>
          <tr>
            <td>Predicted interval</td>
            <td>{{ task['rul_predicted'] }}</td>
            <td>Hours</td>
          </tr>
          </tbody>
        </table>
        <div style="border: 1px solid black; margin-top: 12px; max-width:200mm; min-height:75mm; max-height:75mm; overflow-y:hidden;">
          <highcharts
              style="margin-left: -8px; height:100%; width:calc(100% - 8px);"
              :options="createChart(task)"
          />
        </div>
      </div>
    </page>
  </div>
</template>

<script>

import page from "@/screens/reports/Page.vue";

import {Chart} from 'highcharts-vue'
import More from 'highcharts/highcharts-more'
import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting'

export default {
  name: "CBMEngineView",
  components: {
    page,
    // Chart,
    Highcharts: Chart
  },
  props: {
    engine: '',
    components: [],
    tasks: []
  },
  data() {
    return {
      component_page_size: 40,
      task_page_size: 2,
      chartTemplate: {
        chart: {
          height: 300,
          width: 700
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            },
          }
        },
        series: [
          {
            name: "Standard running hours",
            animation: false,
            data: [[Date.UTC(2021, 1, 1), 0]],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: "Usage-based running hours",
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: "Planned interval",
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          }
        ],
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Time',
            align: 'high'
          },
          crosshair: true
        },
        yAxis: {
          title: {
            text: 'Running Hours',
            align: 'high'
          }
        },
        tooltip: {
          shared: true,
        },
        credits: {enabled: false}
      },
    }
  },
  methods: {
    getPageComponents(page) {
      let start = page * this.component_page_size,
          end = this.component_page_size + page * this.component_page_size

      if (page) {
        --end
      }

      return this.components.slice(start, end)
    },
    getPageTasks(page) {
      let start = page * this.task_page_size,
          end = this.task_page_size + page * this.task_page_size

      return this.tasks.slice(start, end)
    },
    createChart: function (task) {
      let chart = JSON.parse(JSON.stringify(this.chartTemplate))
      chart.series[0].data = task.events.calculated.values
      chart.series[1].data = task.events.predicted.values
      chart.series[2].data = task.events.overhaul_threshold.values

      return chart;
    },
  },
  computed: {
    component_pages: function () {
      let component_pages = Math.ceil(this.components.length / this.component_page_size);

      if (component_pages < 1) {
        component_pages = 1;
      }

      return component_pages;
    },
    task_pages: function () {
      let task_pages = Math.ceil(this.tasks.length / this.task_page_size);

      if (task_pages < 1) {
        task_pages = 1;
      }

      return task_pages;
    }
  }
}
</script>

<style scoped>

</style>